<template>
  <el-upload
    ref="uploadForm"
    class="upload-demo"
    :limit="limit"
    :action="uploadUrl"
    :on-change="handleChange"
    :on-success="success"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :headers="{Accept:'application/json, text/plain, */*'}"
    :with-credentials="true"
    :http-request="httpRequest"
    :file-list="list">
    <el-button size="mini" type="success">点击上传</el-button>
  </el-upload>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFile",
  props:{
    list:Array,
    hostUrl:String,
    limit:{
      type:Number,
      default(){
        return 1
      }
    },
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    }
  },
  data(){
    return {
    }
  },
  mounted() {

  },
  methods:{
    handleChange(file, fileList) {
      // console.log(file, fileList)
    },
    success(response, file, fileList){
      console.log(response, file, fileList)
      let list=[]
      var that=this;
      fileList.map(ret=>{
        list.push({
          name:ret.name,
          url:ret.url||(that.hostUrl(ret.response.data.path.replace('\\','/').replace('//','/')))
        })
      })
      // let file_path=response.data.path.replace('\\','/').replace('//','/');
      that.$emit("success",list)
    },
    removeFun(file, fileList){
      this.$emit("success",fileList)
    },
    previewFun(file){
      window.open(file.url);
    },
    httpRequest(item){
      var that=this;
      console.log(item)
      console.log(item.file)
      // 在这里进行一系列的校验
      let formData = new FormData();
      formData.append("file",item.file);
      // console.log(formData)
      axios.post(item.action,formData).then(res=>{
        console.log(res)
        if(res){
          let file_path=res.data.data.path.replace('\\','/').replace('//','/');
          that.$emit("success",file_path)
        }
      },err=>{
        that.clearFlies()
      })
    },
    clearFlies() {
      this.$refs.uploadForm.clearFiles();
    },
  }
}
</script>

<style lang="scss" scoped>
@import url(../common.scss);
.file-fm{
  justify-content: space-between;
  width: 300px;
  .file-fm-rt{
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/UploadFile.vue